import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import PaginatedFetchTable from '../PaginatedFetchTable';
import Avatar from '../Avatar';
import Icon from '../Icon';
import StatusPill from '../StatusPill';
import LinkCopyButton from '../LinkCopyButton';
import ModalTrigger from '../ModalTrigger';
import DateTimeDisplay from '../DateTimeDisplay';


export default class StaffUsersList extends Component {
  static propTypes = {
    timezone: PropTypes.string,
    bulkReminderUrl: PropTypes.string.isRequired,
    apiUrl: PropTypes.string,
    perPage: PropTypes.number.isRequired,
    emptyImg: PropTypes.string.isRequired,
    defaultSort: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      className: PropTypes.string,
      sort: PropTypes.shape({
        id: PropTypes.string.isRequired,
        direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
      }),
    })).isRequired,
  };

  static defaultProps = {
    timezone: moment.tz.guess(),
    defaultSort: null,
    apiUrl: '',
  }

  constructor(props) {
    super(props);

    this.state = {};
  }

  loaded = (params, totalCount) => {
    const onlyOnboarding = params.states && params.states.length === 1 && params.states[0] === 'onboarding';
    const remindUrl = [this.props.bulkReminderUrl, qs.stringify(params, { arrayFormat: 'brackets', depth: 2 })].join('?');
    this.setState({ totalCount, onlyOnboarding, remindUrl });
  };

  renderRow = (item) => (
    <tr key={item.id}>
      <td>
        <a href={item.staff_url}>
          <div className="u-flex u-items-center">
            <Avatar
              className="StaffTable-avatar u-mr-2"
              src={item.avatar_url}
              type="user"
              showInitials
              name={item.full_name}
            />
            <div className="u-font-semibold u-truncate">
              {item.full_name}
            </div>
          </div>
        </a>
      </td>
      <td>
        <div className="u-truncate">
          { item.companies
            && item.companies.map(company => (
              <>
                <Avatar
                  className="StaffTable-avatar u-align-middle u-mr-2  u-inline-block"
                  src={company.avatar_url}
                  type="company"
                  href={company.staff_url}
                  showInitials
                  name={company.name}
                  />
                <a
                  className="u-font-semibold comma-separated"
                  href={company.staff_url}
                  >
                  {company.name}
                </a>
              </>
            ))}
        </div>
      </td>
      <td>
        <div className="u-truncate">
          {item.email
            && (
              <a href={`mailto:${item.email}`}>{item.email}</a>
            )}
        </div>
      </td>
      <td>
        <div className="u-truncate">
          {item.locations.join(', ')}
        </div>
      </td>
      <td>
        <div className="u-truncate u-capitalize">
          {item.active_roles && item.active_roles.map(role => (<span className="comma-separated">{role}</span>))}
          {item.inactive_roles && item.inactive_roles.map(role => (
            <span
              className="comma-separated u-text-old-primary-color-red"
              data-tooltip=""
              title="Canceled membership"
            >
              {role}
            </span>
          ))}
          {item.onboarding_roles && item.onboarding_roles.map(role => (
            <span className="comma-separated u-text-old-dark-grey" data-tooltip="" title="Onboarding membership">{role}</span>
          ))}
        </div>
      </td>
      <td>
        {item.last_community_activity_date
          && (
            <DateTimeDisplay useTimezone={this.props.timezone} timestamp={item.last_community_activity_date} date_only />
          )}
        {!item.last_community_activity_date && (<span>N/A</span>)}
      </td>
      <td>
        <StatusPill status={item.state} />
      </td>
      <td className="actions">
        <a href={item.edit_staff_url} className="Button u-mr-2">
          <Icon name="edit" className="u-mr-0" />
        </a>
        <div className="u-inline-block">
          <LinkCopyButton url={item.public_url} name={item.full_name} />
        </div>
      </td>
    </tr>
  );

  showBatchActions() {
    return this.state.onlyOnboarding && this.state.totalCount > 0;
  }

  renderBatchActions() {
    const peopleCount = `${this.state.totalCount} ${this.state.totalCount === 1 ? 'person' : 'people'}`;
    return (
      <>
        {this.showBatchActions() && (
          <div className="AlertBox AlertBox--fixedBottom u-bg-old-primary-color">
            <div className="u-flex u-items-center">
              <div className="u-text-left">
                {`You are currently viewing ${peopleCount} that have not yet onboarded.`}
              </div>
              <div className="u-text-right u-flex-grow">
                <ModalTrigger
                  async
                  asyncUrl={this.state.remindUrl}
                  modalWrapperClassName="compact"
                  triggerClassName="Button Button--primary"
                  triggerIcon="Icon Icon-email-digests"
                  triggerLabel={
                    `Send a reminder to ${peopleCount}`
                  }
                  />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  render() {
    const {
      apiUrl, perPage, emptyImg, columns, defaultSort,
    } = this.props;
    return (
      <>
        <div className={this.showBatchActions() ? 'u-mb-12' : ''}>
          <PaginatedFetchTable
            apiUrl={apiUrl}
            perPage={perPage}
            emptyImg={emptyImg}
            columns={columns}
            defaultSort={defaultSort}
            renderRow={this.renderRow}
            onLoad={this.loaded}
          />
        </div>
        {this.renderBatchActions()}
      </>
    );
  }
}
